import makeStyles from '@mui/styles/makeStyles';
import React, {useEffect} from 'react';
import {Link} from 'react-router-dom';
import {useHeaderFooterContext, headerFooterProviderDispatchAction} from '../../context/HeaderFooterProvider';
//import logoFooter from '../../assets/images/logo_footer.png';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      color: theme.palette.text.primary,
      fontFamily: theme.typography.fontFamily,
      backgroundColor: theme.palette.common.white,
      display: 'flex',
      padding: [[15]],
      flexDirection: 'column',
      justifyContent: 'center',
      '& a': {
        color: theme.palette.common.black,
        textDecoration: 'none',
      },
    },
    familyLinks: {
      borderBottom: `1px solid ${theme.palette.a1.border}`,
      fontSize: 13,
      lineHeight: '18px',
      display: 'flex',
      alignSelf: 'center',
      width: '100%',
      padding: [[15, 75]],
      whiteSpace: 'nowrap',
      '& select': {
        marginLeft: 10,
        fontSize: 14,
        width: '80%',
        border: `1px solid ${theme.palette.a1.border}`,
      },
      [theme.breakpoints.up('smx')]: {
        fontWeight: 700,
        justifyContent: 'space-around',
      },
      [theme.breakpoints.up('md')]: {
        //width: 1366,
        maxWidth: 1366,
      },
    },
    siteMap: {
      //borderBottom: `1px solid ${theme.palette.a1.border}`,
      fontSize: 12,
      flexWrap: 'wrap',
      lineHeight: '18px',
      display: 'flex',
      alignSelf: 'center',
      width: '100%',
      padding: [[15, 0]],
      [theme.breakpoints.up('smx')]: {
        justifyContent: 'space-between',
      },
      [theme.breakpoints.up('md')]: {
        maxWidth: 1366,
      },
    },
    siteGroup: {
      display: 'flex',
      flexWrap: 'nowrap',
      flexDirection: 'column',
      minWidth: 360,
      fontSize: '1rem',
      '& ~ $siteGroup': {
        marginTop: 20,
      },
      '& a': {
        marginTop: '0.375rem',
      },
      lineHeight: 1.5,
      padding: [[1, 0]],
      color: theme.palette.text.footerSectionItem,
      [theme.breakpoints.up('smx')]: {
        minWidth: 132,
        marginBottom: 0,
        '& ~ $siteGroup': {
          marginTop: 0,
        },
      },
    },
    siteGroupHeader: {
      fontFamily: theme.typography.fontFamilySerif,
      color: theme.palette.common.black,
      fontSize: '1.25rem',
      fontWeight: 'bold',
      marginBottom: '0.9375rem',
    },
    socialGroupIcons: {
      minWidth: 360,
      display: 'flex',
      '& a': {
        border: '0.0625rem solid #efefef',
        width: '3.125rem',
        height: '3.125rem',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'all .2s ease-in-out',
        marginRight: '0.3125rem',
        opacity: 0.6,
        '&:hover': {
          opacity: 1.0,
        },
      },
    },
    socialGroupIconsVertical: {
      '& a': {
        display: 'flex',
        flexDirection: 'column',
        width: 32,
        height: 32,
      },
      '& a ~ a': {
        marginLeft: 10,
      },
    },
    emergencyGroupIcon: {
      maxWidth: 350,
      fontFamily: theme.typography.fontFamily,
      color: [[theme.palette.text.brownish], '!important'],
      fontWeight: [[400], '!important'],
      fontSize: '0.75rem',
      //margin: [[5, 0]],
      padding: '0.5rem 0rem',
      display: 'flex',
      alignItems: 'center',
      textDecoration: 'none',
      transition: 'color .2s ease-in-out',
      '&:hover': {
        color: [[theme.palette.text.primary], '!important'],
      },
      '& img': {
        height: 32,
        marginRight: 10,
      },
    },
    copyrightLinks: {
      position: 'relative',
      display: 'block',
      listStyle: 'none',
      //flexDirection: 'column',
      //flexDirection: 'row',
      //alignItems: 'flex-start',
      alignSelf: 'center',
      borderBottom: `1px solid ${theme.palette.a1.border}`,
      fontSize: '0.9rem',
      width: '100%',
      paddingBottom: 10,
      '& li': {
        float: 'left',
        paddingBottom: 10,
      },
      '& a': {
        color: theme.palette.text.brownish,
        lineHeight: '21px',
        padding: [[2, 10, 20, 0]],
        // '&:first-of-type': {
        //   paddingTop: 10,
        // },
        transition: 'color .2s ease-in-out',
        '&:hover': {
          color: [[theme.palette.text.primary], '!important'],
        },
        [theme.breakpoints.up('smx')]: {
          // '&:first-of-type': {
          //   paddingTop: 0,
          // },
          fontSize: '1rem',
          marginRight: '0.9375rem',
        },
      },
      '& img': {
        position: 'absolute',
        top: 15,
        right: 20,
        height: 41,
        width: 96,
        objectFit: 'contain',
      },
      [theme.breakpoints.up('smx')]: {
        height: 48,
        //alignItems: 'center',
        //alignSelf: 'center',
        //flexDirection: 'row',
      },
      [theme.breakpoints.up('md')]: {
        //width: 1366,
        maxWidth: 1366,
      },
    },
    group: {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
      alignSelf: 'center',
      //display: 'block',
      padding: [[10, 0]],
      fontSize: '0.9rem',
      width: '100%',
      '& > div:last-of-type': {
        minWidth: 145,
        //margin: [[0, 15]],
      },
      '& ul': {
        listStyle: 'none',
        margin: 0,
        padding: 0,
        '& li': {
          float: 'left',
          padding: [[0, 0, 10, 0]],
        },
      },
      '& a': {
        transition: 'color .2s ease-in-out',
        color: theme.palette.text.brownish,
        lineHeight: '21px',
        '&:hover': {
          color: theme.palette.text.primary,
        },
      },
      '& span': {
        fontWeight: 'bold',
        display: 'block',
        float: 'left',
        paddingTop: 10,
      },
      [theme.breakpoints.up('smx')]: {
        height: 48,
        fontSize: '1rem',
        flexDirection: 'row',
        '& span': {
          display: 'unset',
          float: 'right',
          paddingTop: 0,
        },
      },
      [theme.breakpoints.up('md')]: {
        //width: 1366,
        maxWidth: 1366,
      },
    },
    groupLinks: {
      //display: 'inline-flex',
      //flexWrap: 'wrap',
      //alignItems: 'center',
      '& a': {
        marginRight: '0.9375rem',
      },
    },
  }),
  {name: 'DavaFooter'}
);

const Footer = () => {
  const styles = useStyles();
  //const theme = useTheme();
  //const matchSmxUp = useMediaQuery(theme.breakpoints.up('smx'));
  const {dataLoading, headerJson, headerFooterCallback} = useHeaderFooterContext();

  useEffect(() => {
    if (!headerJson && !dataLoading) headerFooterCallback(headerFooterProviderDispatchAction.FETCH_DATA);
  }, [dataLoading, headerJson, headerFooterCallback]);

  // const handleSelectChange = (e) => {
  //   window.location.href = e.target.value;
  // };

  //const familyLinks = headerJson?.footer?.familyLinks;

  const siteMapLinks = headerJson?.footer?.segments;

  const copyrightLinks = headerJson?.footer?.copyright;

  const groupLinks = headerJson?.footer?.a1Group;

  const navListItem = (groupItem, groupKey) => {
    const renderHorizontal = groupItem.display?.direction === 'horizontal';
    const listItems = groupItem.items?.map((item) => {
      const itemStyle = {
        background: `url('${item.icon}') no-repeat center center`,
        backgroundSize: '1.25rem auto',
      };

      return (
        <Link
          key={item.url}
          style={itemStyle}
          onMouseOver={(e) => {
            if (item.display?.hover) {
              e.target.style.background = `url('${item.display.hover}') 0% 0% / no-repeat center center`;
            }
          }}
          onMouseOut={(e) => {
            if (item.icon) e.target.style.background = `url('${item.icon}') 0% 0% / no-repeat center center`;
          }}
          to={item.url}
          target='_blank'
        ></Link>
      );
    });
    return (
      <div key={groupKey} className={renderHorizontal ? styles.socialGroupIcons : styles.socialGroupIconsVertical}>
        {listItems}
      </div>
    );
  };

  const navIcon = (item) => (
    <Link key={item.url} to={item.url} target='_blank' className={item.icon && styles.emergencyGroupIcon}>
      {item.icon && <img src={item.icon} alt={item.name}></img>}
      {item.name}
    </Link>
  );

  const siteMapGroupRender = (groupItems) =>
    groupItems.map((groupItem, index) => {
      //console.log('groupItem:', groupItem);
      let itemType = groupItem.type;
      switch (itemType) {
        case 'navList':
          return navListItem(groupItem, `groupItem${index}`);

        // case 'navIcon':
        //   return navIcon(groupItem);

        default:
          // return (
          //   <a key={groupItem.name} href={groupItem.url}>
          //     {groupItem.name}
          //   </a>
          // );
          return navIcon(groupItem);
      }
    });

  return headerJson ? (
    <div className={styles.root}>
      {/* <nav className={styles.familyLinks}>
        {!matchSmxUp && familyLinks && (
          <>
            {'skoči na:'}
            <select onChange={handleSelectChange}>
              {familyLinks?.map((familyLink) => (
                <option key={familyLink.name} value={familyLink.url}>
                  {familyLink.name}
                </option>
              ))}
            </select>
          </>
        )}
        {matchSmxUp &&
          familyLinks?.map((familyLink) => (
            <a key={familyLink.name} href={familyLink.url}>
              {familyLink.name}
            </a>
          ))}
      </nav> */}
      <nav className={styles.siteMap}>
        {siteMapLinks?.map((siteMapGroup, idx) => (
          <div key={idx} className={styles.siteGroup}>
            {siteMapGroup.url ? (
              <a key={siteMapGroup.name} href={siteMapGroup.url} className={styles.siteGroupHeader}>
                {siteMapGroup.name}
              </a>
            ) : (
              <span key={siteMapGroup.name} className={styles.siteGroupHeader}>
                {siteMapGroup.name}
              </span>
            )}
            {siteMapGroupRender(siteMapGroup.items)}
          </div>
        ))}
      </nav>
      <lu className={styles.copyrightLinks}>
        {copyrightLinks?.items?.map((copyrightLink) => (
          <li>
            <a key={copyrightLink.name} href={copyrightLink.url}>
              {copyrightLink.name}
            </a>
          </li>
        ))}
      </lu>
      <div className={styles.group}>
        <div className={styles.groupLinks}>
          {groupLinks && (
            <ul>
              <li>
                <a href={groupLinks.url}>{groupLinks.name}</a>
              </li>
              {groupLinks?.items?.map((groupLink) => (
                <li>
                  <a key={groupLink.name} href={groupLink.url}>
                    {groupLink.name}
                  </a>
                </li>
              ))}
            </ul>
          )}
        </div>
        {copyrightLinks?.name && <span>{copyrightLinks?.name}</span>}
      </div>
    </div>
  ) : null;
};

export default Footer;
